import Tool, { type ToolHandler } from '../Tool';
import type { AssistantToolCall } from 'components/framework/models';
import type Agent from '../../agents/Agent';

/**
 * Handler for WhiteboardAgent::GetCurrentWhiteboardContentTool
 * Provides whiteboard data to the tool call
 */
const getCurrentWhiteboardContentToolHandler: ToolHandler = {
  provideToolCallData(
    toolCall: AssistantToolCall,
    agent: Agent
  ): Object | false {
    if (agent.contexts.getWhiteboardController) {
      const controller = agent.contexts.getWhiteboardController();
      return {
        whiteboardData: {
          objects: controller.getContentSummary(),
        },
      };
    } else {
      return false;
    }
  },

  unavailable(agent: Agent): boolean {
    return !agent.contexts.getWhiteboardController;
  },
};

Tool.register(
  'WhiteboardAgent::GetCurrentWhiteboardContentTool',
  getCurrentWhiteboardContentToolHandler
);
